import { useEffect, useState } from 'react';

// True at >= 768px. Used to switch chrome layout (BubbleNav top vs bottom, etc).
export default function useIsDesktop(query = '(min-width: 768px)') {
  const [match, setMatch] = useState(
    typeof window !== 'undefined' ? window.matchMedia(query).matches : true
  );
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = (e) => setMatch(e.matches);
    mq.addEventListener('change', on);
    setMatch(mq.matches);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return match;
}
